import React from "react";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { Grid, InputAdornment, TextField } from "@mui/material";

const TableSearchBar = ({
  selected,
  placeholder,
  handleSearch,
  handleRemove,
}) => {
  return (
    <Grid container alignItems={"center"}>
      <TextField
        variant="outlined"
        placeholder={placeholder ? placeholder : "Search name, phone, email"}
        onChange={
          handleSearch ? (e) => handleSearch(e) : () => console.log("search")
        }
        InputProps={{
          sx: { ...searchTextfieldStyles },
          startAdornment: (
            <InputAdornment position="start">
              <SearchOutlinedIcon />
            </InputAdornment>
          ),
        }}
      />

      {selected && selected.length > 0 && (
        <span
          style={selectedItemsStyles}
          onClick={() => handleRemove(selected)}
        >
          Remove ({selected.length})
        </span>
      )}
    </Grid>
  );
};

export default TableSearchBar;

const searchTextfieldStyles = {
  height: 40,
  border: "none",
  borderColor: "#7676801F",
  borderRadius: 5,
  width: 270,
  background: "#7676801F",
  color: "#515563",
  fontSize: 14,
  fontWeight: 500,
  paddingLeft: 1,
  paddingRight: 2,
  fontFamily: "Avenir Book, sans-serif",
};

const selectedItemsStyles = {
  color: "#BA344C",
  marginLeft: 10,
  marginRight: 10,
  fontSize: 12,
  fontWeight: 700,
  cursor: "pointer",
  fontFamily: "Avenir Book, sans-serif",
};
